import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogIn, UserPlus, ArrowRight, Shield, Users, BookOpen, Calendar } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PageSEO from '../components/PageSEO';
import './R6AdvisoryPage.css';

const R6AdvisoryPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const benefits = [
    { icon: <Users size={22} />, title: 'Dedicated Coach', desc: 'Matched with a senior advisor aligned to your industry and goals.' },
    { icon: <Calendar size={22} />, title: 'Monthly Sessions', desc: 'Scheduled advisory sessions with flexible 30 or 60-minute formats.' },
    { icon: <BookOpen size={22} />, title: 'Training Library', desc: 'Full access to the R6 People Strategy Suite with interactive modules.' },
    { icon: <Shield size={22} />, title: 'Secure Portal', desc: 'Private client dashboard with session history, plans, and resources.' },
  ];

  return (
    <div className="r6a-page" data-testid="r6-advisory-page">
      <PageSEO
        title="R6 Advisory"
        path="/r6-advisory"
        description="Access the R6 Advisory Client Portal. Log in to your existing account or sign up for a monthly advisory retainer with dedicated coaching and training resources."
      />
      <Header />

      {/* Hero */}
      <section className="r6a-hero" data-testid="r6a-hero">
        <div className="r6a-container">
          <div className="r6a-hero-badge">R6 ADVISORY</div>
          <h1 className="r6a-hero-title">Your Strategic<br />Advisory Portal</h1>
          <div className="r6a-hero-line"></div>
          <p className="r6a-hero-subtitle">
            Monthly advisory retainers that pair you with a senior coach, a private client dashboard, and the full R6 People Strategy training suite.
          </p>
        </div>
      </section>

      {/* Action Cards */}
      <section className="r6a-actions" data-testid="r6a-actions">
        <div className="r6a-container">
          <div className="r6a-actions-grid">
            {/* Login Card */}
            <div className="r6a-action-card" data-testid="r6a-login-card">
              <div className="r6a-card-icon login">
                <LogIn size={28} />
              </div>
              <h2>R6 Advisory Login</h2>
              <p>Already a client? Access your dashboard, upcoming sessions, training resources, and your assigned coach.</p>
              <button
                className="r6a-card-btn login"
                onClick={() => navigate('/portal/login')}
                data-testid="r6a-login-btn"
              >
                Log In to Portal <ArrowRight size={16} />
              </button>
            </div>

            {/* Signup Card */}
            <div className="r6a-action-card featured" data-testid="r6a-signup-card">
              <div className="r6a-card-badge">Get Started</div>
              <div className="r6a-card-icon signup">
                <UserPlus size={28} />
              </div>
              <h2>R6 Advisory Sign Up</h2>
              <p>Choose your advisory plan, complete your profile, and begin your subscription to unlock the full R6 client experience.</p>
              <button
                className="r6a-card-btn signup"
                onClick={() => navigate('/portal/signup')}
                data-testid="r6a-signup-btn"
              >
                Create Your Account <ArrowRight size={16} />
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="r6a-benefits" data-testid="r6a-benefits">
        <div className="r6a-container">
          <h2 className="r6a-benefits-title">What's Included</h2>
          <p className="r6a-benefits-subtitle">Every R6 Advisory subscription includes access to these core capabilities.</p>
          <div className="r6a-benefits-grid">
            {benefits.map((b, i) => (
              <div key={i} className="r6a-benefit-card" data-testid={`r6a-benefit-${i}`}>
                <div className="r6a-benefit-icon">{b.icon}</div>
                <h3>{b.title}</h3>
                <p>{b.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="r6a-cta" data-testid="r6a-cta">
        <div className="r6a-container">
          <h2>Ready to Get Started?</h2>
          <p>Sign up for an advisory retainer or schedule a discovery call to learn more about how R6 can support your organization.</p>
          <div className="r6a-cta-buttons">
            <button className="r6a-btn r6a-btn-gold" onClick={() => navigate('/portal/signup')} data-testid="r6a-cta-signup">
              Sign Up Now
            </button>
            <a href="https://form.jotform.com/260186646305054" className="r6a-btn r6a-btn-outline" target="_blank" rel="noopener noreferrer" data-testid="r6a-cta-contact">
              Schedule a Discovery Call
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default R6AdvisoryPage;
